/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const translateChallengeResultItemSchema = z.object({
  lang: z.string(),
  success: z.boolean(),
  error: z.string().optional(),
});

export const translateChallengeResultSchema = z.array(translateChallengeResultItemSchema);

export type ITranslateChallengeResult = z.infer<typeof translateChallengeResultSchema>;

export const translateChallengeResponseSchema = createApiResponseSchema(
  translateChallengeResultSchema,
) as z.ZodSchema<IAPI<ITranslateChallengeResult>>;

export type ITranslateChallengeResponse = IAPI<ITranslateChallengeResult>;
